/**=========================================================
 * Module: transition.js
 * Transition Controller
 =========================================================*/

App.controller('TransitionController',
  ['$rootScope', '$scope', '$state', '$translate', '$window', '$localStorage', '$timeout', 'toggleStateService', 'Restangular',
    function ($rootScope, $scope, $state, $translate, $window, $localStorage, $timeout, toggle, R) {
      "use strict";


      var stateParams = angular.fromJson($state.params.filter);
      
      $timeout(function(){
        $state.go(stateParams.name, {
          action: stateParams.action,
          type: stateParams.type,
          filter: stateParams.filter
        })
      }, 5000);

    }
  ]);